import { createSlice } from '@reduxjs/toolkit'
import name from './name'
import { googleTranslateLanguages } from './languages'

const initialState = {
  content: undefined,
  isUrlAdjusted: false,
  list: [],
  modal: undefined,
  language: 'en',
  translation: undefined,
  isTranslating: false,
  allLanguages: googleTranslateLanguages,
  hasRecommend: false,
  recommendCount: 0,
  isExclusive: false,
  isPreview: false,
  isMeteringEnabled: false,
  meteringLimit: undefined,
  meteringUsed: undefined
}

export const content = createSlice({
  name,
  initialState,
  reducers: {
    setContent: (state, { payload }) => {
      if (!payload?.content) return { ...initialState }
      state.content = { ...payload.content }
      state.isPreview = payload.isPreview
      state.isMeteringEnabled = payload.isMeteringEnabled
      state.meteringLimit = payload.meteringLimit
      state.meteringUsed = payload.meteringUsed
      state.isExclusive = payload.isExclusive
      state.translation = {
        title: payload.content.title,
        subtitle: payload.content.subtitle.html,
        body: payload.content.body
      }
    },
    setContentTranslation: (state, { payload }) => {
      state.translation = {
        title: payload.title,
        subtitle: payload.subtitle,
        body: payload.body
      }
    },
    showModal: (state, { payload }) => {
      state.modal = payload
    },
    setIsTranslating: (state, { payload }) => {
      state.isTranslating = payload
    },
    setLanguage: (state, { payload }) => {
      state.language = payload
    },
    recommendToggle: (state, { payload }) => {
      const { hasRecommend, recommendCount } = payload

      state.content = {
        ...state.content,
        hasRecommend,
        recommendCount
      }
    },
    setIsUrlAdjusted: (state, { payload }) => {
      state.isUrlAdjusted = payload
    },
    reset: state => initialState
  }
})

export const {
  showModal,
  setContent,
  setLanguage,
  setIsTranslating,
  setContentTranslation,
  recommendToggle,
  setIsUrlAdjusted,
  reset
} = content.actions

export default content.reducer
